import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import $ from 'jquery';
import './login.css';
const Login = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  

  const handleLogin = (e) => {
    e.preventDefault();
    $('#loading').show();
  
    const apiUrl = `${baseURL}/login-drf/`;
    const requestBody = {
      username: username,
      password: password,
    };
  
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify(requestBody),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Invalid Credentials');
        }
        return response.json();
      })
      .then(data => {
        console.log('Login successful:', data);
        if (rememberMe) {
          localStorage.setItem('access_token', data.access_token);
          sessionStorage.removeItem('access_token');
        } else {
          sessionStorage.setItem('access_token', data.access_token);
          localStorage.removeItem('access_token');
        }
        $('#loading').hide();
        if (data.status === true) {
          navigate('/home');
        } else {
          throw new Error('Invalid Credentials');
        }
      })
      .catch(error => {
        console.error('Error during login:', error.message);
        toastr.error(error.message);
      })
      .finally(() => {
        $('#loading').hide();
      });
  };
  

  return (
    <div className="login-page">
      <div id="loading">
        <div className="loader">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <div className="loader-text">Loading...</div>
        </div>
      </div>

      <div className="login-card">
        {/* Brand */}
        <div className="login-brand">
          <div className="login-brand-icon">⚡</div>
          <div className="login-brand-text">
            <span className="login-brand-title">TMS Lead Management</span>
            <span className="login-brand-sub">Dashboard &amp; Analytics</span>
          </div>
        </div>

        <hr className="login-divider" />

        <h2 className="login-heading">Welcome back</h2>
        <p className="login-subheading">Sign in to your account to continue</p>

        <form onSubmit={handleLogin}>
          <div className="login-form-group">
            <label className="login-label" htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              className="login-input"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="login-form-group">
            <label className="login-label" htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              className="login-input"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="login-remember">
            <input type="checkbox" id="rememberMe" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
            <label htmlFor="rememberMe">Remember me</label>
          </div>

          <button type="submit" className="login-btn">Sign In</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
